import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";

const memberLaboratoryPath = "/members/:memberId/laboratories/";
const laboratoryBasePath = "/members/laboratories/";
const laboratoryPathById = `${laboratoryBasePath}:labId/`;
const projectsBasePath = `${laboratoryPathById}projects/`;
const projectsPathById = `${projectsBasePath}:projectId`;
const studentsBasePath = `${laboratoryPathById}students/`;
const studentsPathById = `${studentsBasePath}:studentId`;

export type IMemberLaboratoryPathParam = IExtractParams<
  typeof memberLaboratoryPath
>;
export type ILaboratoryPathParam = IExtractParams<typeof laboratoryPathById>;
export type ILaboratoryProjectsPathParam = IExtractParams<
  typeof projectsPathById
>;
export type ILaboratoryStudentsPathParam = IExtractParams<
  typeof studentsPathById
>;

export const laboratories = {
  getAll: (param: IMemberLaboratoryPathParam) =>
    generatePath(memberLaboratoryPath, param),
  post: (param: IMemberLaboratoryPathParam) =>
    generatePath(memberLaboratoryPath, param),
  get: (param: ILaboratoryPathParam) => generatePath(laboratoryPathById, param),
  put: (param: ILaboratoryPathParam) => generatePath(laboratoryPathById, param),
  patch: (param: ILaboratoryPathParam) =>
    generatePath(laboratoryPathById, param),
  delete: (param: ILaboratoryPathParam) =>
    generatePath(laboratoryPathById, param),
  projects: {
    getAll: (param: ILaboratoryPathParam) =>
      generatePath(projectsBasePath, param),
    post: (param: ILaboratoryPathParam) =>
      generatePath(projectsBasePath, param),
    get: (param: ILaboratoryProjectsPathParam) =>
      generatePath(projectsPathById, param),
    put: (param: ILaboratoryProjectsPathParam) =>
      generatePath(projectsPathById, param),
    patch: (param: ILaboratoryProjectsPathParam) =>
      generatePath(projectsPathById, param),
    delete: (param: ILaboratoryProjectsPathParam) =>
      generatePath(projectsPathById, param),
  },
  students: {
    getAll: (param: ILaboratoryPathParam) =>
      generatePath(studentsBasePath, param),
    post: (param: ILaboratoryPathParam) =>
      generatePath(studentsBasePath, param),
    get: (param: ILaboratoryStudentsPathParam) =>
      generatePath(studentsPathById, param),
    put: (param: ILaboratoryStudentsPathParam) =>
      generatePath(studentsPathById, param),
    patch: (param: ILaboratoryStudentsPathParam) =>
      generatePath(studentsPathById, param),
    delete: (param: ILaboratoryStudentsPathParam) =>
      generatePath(studentsPathById, param),
  },
};
